import { useEffect } from "react";
import { initHeronSignal } from "@heronsignal/web";

export function HeronSignalProvider() {
  useEffect(() => {
    initHeronSignal({
      publicKey: import.meta.env.VITE_HERONSIGNAL_PUBLIC_KEY || "pk_xzu1x_V38I8pLdRI-T0MfjWC9yS3YZPP",
      captureRuntimeErrors: true,
      captureNetworkFailures: true,
    }).catch(() => {
      // Non-critical analytics tracker; ignore load/init failures (e.g. blocked by in-app browsers, ad blockers).
    });
  }, []);

  return null;
}
